'use strict';

(function(itxApp) { // jshint ignore:line

    angular.module('itxApp.common')
    .factory('itxmSpotUtilsSvc', itxmSpotUtilsSvc);

    itxmSpotUtilsSvc.$inject = [
        'DUTTI_CONS',
        'itxAkamaiSvc',
        '$q',
        'CmsConfigSvc',
        'ItxConfigurationSvc'
    ];
    
    function itxmSpotUtilsSvc(
        DUTTI_CONS, 
        itxAkamaiSvc, 
        $q,
        CmsConfigSvc,
        ItxConfigurationSvc
    ) {
        var forcedKeys = {};
        var forcedKeysLoaded = false;
        
        var showProperties = false;
        if(ItxConfigurationSvc.isDebugActive()){
            showProperties = ItxConfigurationSvc.getDebugOptions().properties;
        }

        var checkPlan = function(str) {
            if (!str) {
                return false;
            }
            var params = str.split('_');

            var init = moment.tz(params[2], 'DD-MM-YYYY HH:mm:ss', 'Europe/Madrid');
            var end = moment.tz(params[3], 'DD-MM-YYYY HH:mm:ss', 'Europe/Madrid');
            if (!window.date) {
                console.trace('No DATE!!!!');
                return false;
            }

            var res = window.date.isBetween(init, end);

            return res;
        };

        return {
            getString: function(text, force) {

                var deferred = $q.defer();
                var promise = deferred.promise;


                itxAkamaiSvc.getDate().then(function() {

                    var store = DUTTI_CONS.i_stores['' + inditex.iStoreId]; // jshint ignore:line
                    var lang = DUTTI_CONS.i_languages['' + inditex.iLangId];
                    var translations = false;
                    if(window.configurationContent && window.configurationContent.mspots){
                        translations = window.configurationContent.mspots[inditex.iStoreId];
                    }
                    
                    if (!translations) {
                        return deferred.resolve(null);
                    }

                    var plans = Object.keys(translations);
                    var isValid;
                    var preparePlan = function(plan, def) {
                        if (!translations[plans[plan]] || !translations[plans[plan]][lang]) {
                            if (def) {
                                return deferred.resolve(null);
                            } else {
                                return false;
                            }
                        } else {

                            isValid = checkPlan(plans[plan]);
                            if (isValid) {
                                _getTranslation(translations[plans[plan]][lang], text, force).then(function(text){
                                    deferred.resolve(text);
                                })
                                return true;
                            } else if (def) {
                                return deferred.resolve(null);
                            } else {
                                return false;
                            }
                        }
                    };
                    if (!preparePlan(8)) {
                        if (!preparePlan(7)) {
                            if (!preparePlan(6)) {
                                if (!preparePlan(5)) {
                                    if (!preparePlan(4)) {
                                        if (!preparePlan(3)) {
                                            if (!preparePlan(2)) {
                                                if (!preparePlan(1)) {
                                                    preparePlan(0, true);
                                                }
                                            }
                                        }
                                    }
                                }       
                            }
                        }
                    }

                });

                return promise;
            }
        };

        function _getTranslation(array, text, force) {
            var deferred = $q.defer();
            if(showProperties && !force){
                deferred.resolve(text);
            } else if (!forcedKeysLoaded){
                CmsConfigSvc.getProperty('mspotsforced').then(function(res){
                    forcedKeys = res;
                    forcedKeysLoaded = true;
                    if(forcedKeys[text]){
                        CmsConfigSvc.getTranslation(forcedKeys[text], [])
                        .then(function(res){
                            if(res.indexOf('???')>-1){
                                deferred.resolve(array[text]);
                            } else {
                                deferred.resolve(res);
                            }
                        })
                    } else {
                        deferred.resolve(array[text]);
                    }

                }).catch(function(err) {
                    forcedKeysLoaded = true;
                    deferred.resolve(array[text]);
                });
            } else {

                if(forcedKeys[text]){
                    CmsConfigSvc.getTranslation(forcedKeys[text], [])
                    .then(function(res){
                        if(res.indexOf('???')>-1){
                            deferred.resolve(array[text]);
                        } else {
                            deferred.resolve(res);
                        }
                    })
                } else {
                    deferred.resolve(array[text]);
                }

            }
            return deferred.promise;
        }
    }

})(window.itxApp);